import React from 'react';
import { Button } from './ui/Button';
import { Star } from 'lucide-react';
const CHECKOUT_URL = 'https://www.tubienestarinterno.com/cart/53266912084305:1';
export function HeroSection() {
  const goToCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <section id="hero" className="relative pt-10 pb-6 md:pt-16 md:pb-10 px-4 overflow-hidden bg-cream" data-id="element-105">
      <div className="max-w-6xl mx-auto animate-fade-in-up" data-id="element-106">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-107">
          {/* Left: Text Content */}
          <div className="flex-1 text-center md:text-left" data-id="element-108">
            {/* Eyebrow */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-gray-200 text-deep-blue text-sm font-semibold mb-6 shadow-sm" data-id="element-109">
              <span className="flex gap-1" data-id="element-110">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-warm-accent text-warm-accent" data-id="element-111" />)}
              </span>
              <span data-id="element-112">+4.500 padres ya lo aplican</span>
            </div>

            {/* Headline */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-deep-blue mb-5 leading-[1.1]" data-id="element-113">
              ¿Tu hijo se "transforma"{' '}
              <span className="text-warm-accent" data-id="element-114">al apagar la tablet?</span>
            </h1>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-deep-blue/80 mb-6 leading-relaxed" data-id="element-115">
              Aplica el <strong data-id="element-116">Neuro-Reset de 3 Minutos</strong> y recupera la
              paz en tu salón hoy mismo. Sin gritos, sin berrinches y sin
              repetir las cosas 20 veces.
            </p>

            {/* CTA Area */}
            <div className="flex flex-col items-center md:items-start gap-3 relative z-10" data-id="element-117">
              <Button onClick={goToCheckout} className="animate-pulse-soft" data-id="element-118">
                QUIERO PAZ EN CASA POR 6,95€
              </Button>
              <p className="text-sm text-deep-blue/60 flex items-center gap-2 mt-1 font-medium" data-id="element-119">
                ✅ Pago único. Acceso inmediato. Compatible con móvil.
              </p>
            </div>
          </div>

          {/* Right: Product Mockup Image */}
          <div className="flex-1 w-full max-w-lg md:max-w-none" data-id="element-120">
            <img src="https://cdn.magicpatterns.com/uploads/kBX7T79CqC4oXKyjurDsGx/imagen_producto_y_bonos.png" alt="Protocolo Cero Gritos - Manual Digital, Guía SOS Berrinches y Guía de Frases Exactas" className="w-full h-auto drop-shadow-2xl" data-id="element-121" />
          </div>
        </div>
      </div>
    </section>;
}